import { PageTitle } from "components/Common/pageTitle/PageTitle";
import React, { useState, useEffect } from "react";
import websiteLogo from "../../images/sinecure_new_logo.png";
import Button from "components/Common/Button";
import { useNavigate } from "react-router-dom";

export const AfterSignUp = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(20);

  const handleLogin = () => {
    window.location.href = "/auth/login";
  };

  useEffect(() => {
    if (countdown <= 0) {
      handleLogin();
      return;
    }
    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  // ✅ Load Google Analytics gtag script
  useEffect(() => {
    // Load script dynamically
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-R2XFTNWTJ4";
    script.async = true;
    document.head.appendChild(script);
    const win = window as any;

    // Initialize gtag after script loads
    script.onload = () => {
      win.dataLayer = win.dataLayer || [];
      function gtag(...arg: any[]) {
        // eslint-disable-next-line prefer-rest-params
        win.dataLayer.push(arguments);
      }

      win.gtag = gtag;
      gtag("js", new Date());
      gtag("config", "G-R2XFTNWTJ4");
    };

    return () => {
      document.head.removeChild(script); // cleanup
    };
  }, []);

  return (
    <>
      <PageTitle>Thank You</PageTitle>
      <div className="other-page-wrapper thankyou-page min-h-screen flex flex-col items-center justify-center px-4 py-12 sm:px-8 lg:px-24">
        <img className="mx-auto h-8 w-auto mb-4" src={websiteLogo} alt="Your Company" />
        <div className="sm:w-full text-center" style={{ maxWidth: "70%" }}>
          <p className="text-fonttext-primary mt-6 text-base font-normal">
            <strong>Welcome aboard!</strong> You&apos;re officially on your way to reclaiming
            precious hours and hiring smarter with{" "}
            <span className="text-[#00B0F0]">Sinecure.ai</span>.
          </p>
          <p className="mt-4 text-fonttext-primary text-base font-normal">
            Keep an eye on your inbox for your welcome email packed with helpful resources to
            kickstart your journey.
          </p>
          <p className="mt-4 text-fonttext-primary text-base font-normal">
            In the meantime, explore our <strong>quick-start guide</strong> or reach out to our
            friendly support team any time.
          </p>
          <p className="mt-8 text-fonttext-primary text-base font-normal">
            Happy hiring!
            <br />
            <strong>
              The <span className="text-[#00B0F0]">Sinecure.ai</span> Team
            </strong>
          </p>
          <p className="mt-10 text-fonttext-primary text-base font-normal flex items-center justify-center">
            <Button
              onClick={handleLogin}
              variant="primary"
              className="bg-primary text-white px-4 py-2 rounded-md w-full sm:w-auto flex items-center justify-center gap-2"
            >
              Go To Login
            </Button>
          </p>
        </div>
      </div>
    </>
  );
};

export default AfterSignUp;
